<template>
  <div>
    <CRow>
      <CCol sm="12">
        <AssetDepartamentsTable
          :items="asset_departaments"
          hover
          striped
          border
          small
          fixed
          caption="Departamentos"
          @refresh="refreshItems"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import AssetDepartamentsTable from '../../components/asset_departaments/AssetDepartamentsTable.vue'
import ws from '../../services/asset_departaments';
import store from '../../store'

export default {
  name: 'AssetDepartaments',
  components: { AssetDepartamentsTable },
  data: function () {
		return {
            asset_departaments: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.asset_departaments = response.data;
    }

    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      this.asset_departaments = await items;
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
